/* eslint-disable no-underscore-dangle */
import { Button, CircularProgress, OutlinedInput } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './style';
import { ReactComponent as M3 } from '../../../../Asset/svg/matching3.svg';
import { useHistory } from 'react-router-dom';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { useMemo } from 'react';

interface IMatching {
  data: any;
  linkEbook?: string;
  linkResultTest: string;
}

const MatchingPersonality = (props: IMatching) => {
  const classes = useStyles();
  const history = useHistory();
  const { data, linkEbook, linkResultTest } = props;

  const { personality, personalityProfil } = useMemo(() => {
    return { personality: data?._data?.job || {}, personalityProfil: data?._data?.candidat || {} };
  }, [data]);

  return (
    <div className={classes.containerMatch}>
      <Grid container={true} alignItems="center" justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <M3 style={{ width: 30, height: 33, marginRight: 15 }} />
          <Typography className={classes.matchTitle}>
            Matching <span>Personnalité</span>
          </Typography>
        </Grid>
        <Grid item={true} lg="auto">
          {data?.isComplete && (
            <CircularProgressCustom
              value={Math.round(data?.totalPercent || 0)}
              color="#FE5756"
              size={40}
              fontSize={12}
              fontSizeFloat={12}
              isPercent={true}
            />
          )}
        </Grid>
      </Grid>
      {/* Test des 7 besoins Needs pro® */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>
            Test des 32 personnalités - Préférences®
          </Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            disabled={linkResultTest === ''}
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => linkResultTest && history.push(linkResultTest)}>
            Accès résultats
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: 20 }} container={true} item={true}>
        {/* Header */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopLeftRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderLeft: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}
        />
        <Grid
          item={true}
          lg={4}
          style={{
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Requis
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopRightRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Candidat
            </Typography>
          </div>
        </Grid>
        {/* Header */}

        {/* body */}
        <Grid
          item={true}
          container={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <Grid item={true} lg={2} className={classes.celluleNumber}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                1
              </Typography>
            </div>
          </Grid>
          <Grid item={true} lg={10} className={classes.celluleTexte}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                Préférence relationnelle
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{
                color:
                  personalityProfil['Préférence relationnelle'] !==
                  personality['Préférence relationnelle']
                    ? '#E63C3C'
                    : '',
              }}>
              {personality['Préférence relationnelle'] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !personalityProfil['Préférence relationnelle']
                ? classes.celluleKO
                : personalityProfil['Préférence relationnelle'] ===
                  personality['Préférence relationnelle']
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!personalityProfil['Préférence relationnelle'] ? (
                ''
              ) : personalityProfil['Préférence relationnelle'] ===
                personality['Préférence relationnelle'] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {personalityProfil['Préférence relationnelle'] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          container={true}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <Grid item={true} lg={2} className={classes.celluleNumber}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                2
              </Typography>
            </div>
          </Grid>
          <Grid item={true} lg={10} className={classes.celluleTexte}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                Préférence perceptive
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{
                color:
                  personalityProfil['Préférence perceptive'] !==
                  personality['Préférence perceptive']
                    ? '#E63C3C'
                    : '',
              }}>
              {personality['Préférence perceptive'] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !personalityProfil['Préférence perceptive']
                ? classes.celluleKO
                : personalityProfil['Préférence perceptive'] ===
                  personality['Préférence perceptive']
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!personalityProfil['Préférence perceptive'] ? (
                ''
              ) : personalityProfil['Préférence perceptive'] ===
                personality['Préférence perceptive'] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {personalityProfil['Préférence perceptive'] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          container={true}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <Grid item={true} lg={2} className={classes.celluleNumber}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                3
              </Typography>
            </div>
          </Grid>
          <Grid item={true} lg={10} className={classes.celluleTexte}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                Préférence émotionnelle
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{
                color:
                  personalityProfil['Préférence émotionnelle'] !==
                  personality['Préférence émotionnelle']
                    ? '#E63C3C'
                    : '',
              }}>
              {personality['Préférence émotionnelle'] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !personalityProfil['Préférence émotionnelle']
                ? classes.celluleKO
                : personalityProfil['Préférence émotionnelle'] ===
                  personality['Préférence émotionnelle']
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!personalityProfil['Préférence émotionnelle'] ? (
                ''
              ) : personalityProfil['Préférence émotionnelle'] ===
                personality['Préférence émotionnelle'] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {personalityProfil['Préférence émotionnelle'] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          container={true}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <Grid item={true} lg={2} className={classes.celluleNumber}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                4
              </Typography>
            </div>
          </Grid>
          <Grid item={true} lg={10} className={classes.celluleTexte}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                Préférence comportementale
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{
                color:
                  personalityProfil['Préférence comportementale'] !==
                  personality['Préférence comportementale']
                    ? '#E63C3C'
                    : '',
              }}>
              {personality['Préférence comportementale'] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !personalityProfil['Préférence comportementale']
                ? classes.celluleKO
                : personalityProfil['Préférence comportementale'] ===
                  personality['Préférence comportementale']
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!personalityProfil['Préférence comportementale'] ? (
                ''
              ) : personalityProfil['Préférence comportementale'] ===
                personality['Préférence comportementale'] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {personalityProfil['Préférence comportementale'] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          container={true}
          style={{
            borderBottomLeftRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <Grid item={true} lg={2} className={classes.celluleNumber}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                5
              </Typography>
            </div>
          </Grid>
          <Grid item={true} lg={10} className={classes.celluleTexte}>
            <div className={classes.cellule}>
              <Typography variant="h6" className={classes.celluleFigure}>
                Préférence environnementale
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderRight: '1px solid #5E65A3', borderBottom: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{
                color:
                  personalityProfil['Préférence environnementale'] !==
                  personality['Préférence environnementale']
                    ? '#E63C3C'
                    : '',
              }}>
              {personality['Préférence environnementale'] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottomRightRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div
            className={
              !personalityProfil['Préférence environnementale']
                ? classes.celluleKO
                : personalityProfil['Préférence environnementale'] ===
                  personality['Préférence environnementale']
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!personalityProfil['Préférence environnementale'] ? (
                ''
              ) : personalityProfil['Préférence environnementale'] ===
                personality['Préférence environnementale'] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {personalityProfil['Préférence environnementale'] || 'NC'}
            </Typography>
          </div>
        </Grid>
      </Grid>
      {/* Test des 7 besoins Needs pro® */}
    </div>
  );
};

export default MatchingPersonality;
